export const auth_token_key = '@AUTH_TOKEN';
